<template>
    <div class="absolute top-0 w-full flex justify-center">
        <div
            v-if="DebtCollectionSynchronizer.isEnabled()"
            ref="toggler"
            class="absolute w-fit select-none border border-base-300 shadow-sm py-0.5 px-2 bg-gradient-to-br from-base-100 to-base-200 cursor-pointer"
            @click="showDebtCollectionSynchronizer = !showDebtCollectionSynchronizer"
        >
            Debug Kravia
        </div>
        <div
            v-if="showDebtCollectionSynchronizer"
            ref="devDebtCollectionSynchronizer"
            class="mt-2 border border-base-300 rounded p-2 bg-base-100 z-10 shadow-2xl w-fit h-fit flex flex-col gap-2"
            :style="floatingStyles"
        >
            <div class="my-1">For Debug: Synkronisering av data til/fra Kravia</div>
            <div>
                Send forfalte faktura til Kravia
                <button class="btn btn-xs bg-base-300" :disabled="pastDueSyncWorking" @click="synchronizePastDueInvoices">
                    {{ pastDueSyncWorking ? 'Jobber...' : 'Start sync' }}
                </button>
            </div>
            <div>
                Hent oppdaterte faktura fra Kravia
                <button class="btn btn-xs bg-base-300" :disabled="fetchExternallyUpdatedInvoicesWorking" @click="synchronizeExternallyUpdatedInvoices">
                    {{ fetchExternallyUpdatedInvoicesWorking ? 'Jobber...' : 'Start sync' }}
                </button>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import {ref} from 'vue'
import {useFloating} from '@floating-ui/vue'
import {syncExternallyUpdatedInvoices, syncPastDueInvoicesToDebtCollection} from '@/invoice/invoice.service'
import {DebtCollectionSynchronizer} from '@/transaction/create-transaction/feature-toggles'

const toggler = ref(null)
const devDebtCollectionSynchronizer = ref(null)
const {floatingStyles} = useFloating(toggler, devDebtCollectionSynchronizer)
const pastDueSyncWorking = ref(false)
const fetchExternallyUpdatedInvoicesWorking= ref(false)

const showDebtCollectionSynchronizer = ref(false)

const synchronizePastDueInvoices = async () => {
    pastDueSyncWorking.value = true
    await syncPastDueInvoicesToDebtCollection()
    pastDueSyncWorking.value = false
}

const synchronizeExternallyUpdatedInvoices = async () => {
    fetchExternallyUpdatedInvoicesWorking.value = true
    await syncExternallyUpdatedInvoices()
    fetchExternallyUpdatedInvoicesWorking.value = false
}
</script>

<style scoped>

</style>